module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("\n                            " + _vm._s(_vm.getRouteName(_vm.$route)) + " " + _vm._s(_vm.types[_vm.form.resourcetype] &&
    _vm.types[_vm.form.resourcetype].label) + "\n                        ")]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa robocza",
      "error": _vm.errors['working_name']
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Nazwa robocza dla administratorów"
    },
    model: {
      value: (_vm.form['working_name']),
      callback: function($$v) {
        _vm.$set(_vm.form, 'working_name', $$v)
      },
      expression: "form['working_name']"
    }
  })], 1), _vm._v(" "), _c('base-widget', {
    attrs: {
      "form": _vm.form,
      "errors": _vm.errors
    },
    on: {
      "update:form": function($event) {
        _vm.form = $event
      }
    }
  }), _vm._v(" "), _c(_vm.widgetComponent, {
    tag: "component",
    attrs: {
      "form": _vm.form,
      "errors": _vm.errors
    },
    on: {
      "update:form": function($event) {
        _vm.form = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e251abd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Widgets/WidgetForm.vue
// module id = 807
// module chunks = 0